import { GridOptions} from "@ag-grid-community/core";
import { AccountCellRendererComponent } from "src/app/ag-grid-components/account-cell-renderer/account-cell-renderer.component";
import { ChannelsCellRendererComponent } from "src/app/ag-grid-components/channels-cell-renderer/channels-cell-renderer.component";
import { OrderStatusCellRendererComponent } from "src/app/ag-grid-components/order-status-cell-renderer/order-status-cell-renderer.component";
import { ShipmentNameCellRendererComponent } from "src/app/ag-grid-components/shipment-name-cell-renderer/shipment-name-cell-renderer.component";
import { SkuCellRendererComponent } from "src/app/ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { HumanizeDatePipe } from "src/app/pipes/humanize-date.pipe";  

  const humanizeDatePipe = new HumanizeDatePipe("en-US");
  export const shipmentColumnDefs: any = [
    {
      field: "ShipmentId",
      backendFields: ["ShipmentId","ShipmentName","ShipmentHeaderId"],
      cellRenderer: "shipmentNameCellRendererComponent",    
      headerName: "Shipment ID",
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ShipmentId",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ShipmentName",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
      width: 400,
    },
    {
      field: "Status", 
      backendFields: ["Status"],
      cellRenderer: "orderStatusCellRendererComponent",       
      width: 180,        
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["Draft", "Deleted", "Working","Closed"],
      },   
    },
    {
      field: "Account",
      headerName: "Account Name",
      filter:'agTextColumnFilter',
      backendFields: ["Account"],
      cellRenderer: "accountCellRendererComponent",
      width: 200,
    },
    {
      field: "Sku",
      backendFields: [
        "ImageUrl",
        "Sku",
        "Asin",
        "Title",
        "AccountType",
        "FulfillmentType",
      ],
      headerName: "SKU",
      minWidth: 440,
      cellRenderer: "skuCellRendererComponent",     
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "SKU",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            filter: "agTextColumnFilter",
            display: "accordion",
            title: "ASIN",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
          {
            display: "accordion",
            title: "Title",
            filter: "agTextColumnFilter",
            filterParams: {
              defaultOption: "contains",
              maxNumConditions : 1,
            },
          },
        ],
      },
   },
    {
      field: "TotalQty",
      backendFields: ["TotalQty"],
      width: 180,  
      filter:'agNumberColumnFilter',
      headerName:'Qty shipped',
      valueGetter: (params) => {
        return (Number(params.data.TotalQty) || 0).toLocaleString('en');
      },        
    },
    {
      field: "ReceivedQty",
      backendFields: ["ReceivedQty"],
      filter:'agNumberColumnFilter',
      width: 180,  
      headerName:'Qty received',
      valueGetter: (params) => {
        return (Number(params.data.ReceivedQty) || 0).toLocaleString('en');
      },      
    },
    {
      field: "ShipTo",
      backendFields: ["ShipTo"],
      width: 180,  
      headerName:'Ship To',
      cellRenderer: "channelsCellRendererComponent",  
      cellRendererParams: (params) => {
        return {
          channels: [params.data.ShipTo],
          large:true
        };
      },
    },
    {
      field: "DateShipped",
      filter:'agDateColumnFilter',
      filterParams :{
        defaultOption: "inRange",
            filterOptions: [
              "lessThan",
              "greaterThan",
              {
                displayKey: "inRange",
                displayName: "Between",
                test: {},numberOfInputs:2
              },
            ],
      },
      backendFields: ["DateShipped"],
      width: 180,  
      headerName:'Shipped date',
      valueFormatter: (params) => params.value ? humanizeDatePipe.transform(params.value, 'MM/dd/yyyy') : '',      
    },
    
  ];
  
  const frameworkComponents = {    
    skuCellRendererComponent:SkuCellRendererComponent,
    shipmentNameCellRendererComponent:ShipmentNameCellRendererComponent,
    orderStatusCellRendererComponent:OrderStatusCellRendererComponent,
    accountCellRendererComponent:AccountCellRendererComponent,
    channelsCellRendererComponent:ChannelsCellRendererComponent
  };
  
  export const shipmentGridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    rowHeight: 42,
    defaultColDef: {
      resizable: true,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
    },
    components: frameworkComponents,
  };
  